import { Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import type { Automation } from 'modules/automations/store/models/Automation'

interface Props {
  automation: Automation
  setActivationModal: (value: boolean) => void
}

export function ActivationModal({ automation, setActivationModal }: Props) {
  const { running, performAction } = useAsyncAction(async () => {
    await automation.activate(true)
    app.setFlash({
      type: 'correct',
      message: i18n.t('common.saved_successfully'),
    })
    setActivationModal(false)
  })

  return (
    <Modal
      illustration="automations"
      title={i18n.t('automations.show.details.activation_modal.title')}
      description={
        <>
          <Text.Normal>
            {i18n.t('automations.show.details.activation_modal.description')}
          </Text.Normal>
          <Text.Normal>
            {i18n.t('automations.show.details.activation_modal.description2')}
          </Text.Normal>
        </>
      }
      onClose={() => setActivationModal(false)}
      onSubmit={() => performAction()}
      locked={running}
      footer={
        <>
          <Button type="secondary" onClick={() => setActivationModal(false)}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('automations.show.details.activation_modal.submit')}</Button>
        </>
      }
    />
  )
}
